import api from './index';

export const apiIncludeAddress = async (address) => {
  try {
    const { data } = await api.post('/address', { address });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiIncludeAddressCompany = async (address, company_id) => {
  try {
    const { data } = await api.post(`companies/${company_id}/addresses`, { ...address, company_id });
    return data;
  } catch (error) {
    throw (error);
  }
};

export const apiEditAddressCompany = async (address, company_id) => {
  try {
    const { data } = await api.put(`companies/${company_id}/addresses/${address.id}`, { ...address, company_id });
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiEditAddress = async (address) => {
  try {
    const { data } = await api.put(`address/${address.id}`, { address });
    return data;
  } catch (err) {
    throw err;
  }
};

export const apiFindAddressByCompanyAndUser = async (user_id) => {
  try {
    const { data } = await api.get(`address/user/${user_id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const checkIfIsAddressCompany = async (local, service_id) => {
  try {
    const { data } = await api.post('address/validate-from-company', { ...local, service_id });
    return data;
  } catch (error) {
    throw error;
  }
};
